module.exports = __webpack_public_path__ + "static/media/everyreel.6d02cf01.svg";